import { render, staticRenderFns } from "./ActiveTrips.vue?vue&type=template&id=278ee17e&scoped=true&"
import script from "./ActiveTrips.vue?vue&type=script&lang=js&"
export * from "./ActiveTrips.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTrips.vue?vue&type=style&index=0&id=278ee17e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ee17e",
  null
  
)

export default component.exports